var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnAlertHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "#B6B8D5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82052 6.96585C9.48577 7.06117 9.13237 7.1122 8.76705 7.1122C6.64686 7.1122 4.92812 5.39345 4.92812 3.27327C4.92812 2.89493 4.98285 2.52937 5.08482 2.18408H1.10704C0.495639 2.18408 0 2.67972 0 3.29112V10.8976C0 11.509 0.495639 12.0046 1.10704 12.0046H8.71348C9.32488 12.0046 9.82052 11.509 9.82052 10.8976V6.96585Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0027 2.72792C12.0027 4.23451 10.7814 5.45585 9.2748 5.45585C7.76821 5.45585 6.54688 4.23451 6.54688 2.72792C6.54688 1.22133 7.76821 0 9.2748 0C10.7814 0 12.0027 1.22133 12.0027 2.72792Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnAlertHistory);
export default __webpack_public_path__ + "static/media/icn-alert-history.e359a526f1d2e0e0aed9a34121abbdcd.svg";
export { ForwardRef as ReactComponent };